import * as _ from 'lodash'

export const formasUnique = (products) => {
    const formasAll = []
    for (let i = 0; i < products.length; i++) {
        if (products[i].Forma !== '') {
            formasAll.push({ nombre: products[i].Forma.trim() })
        }
    }
    let distinct = _.uniqBy(formasAll, 'nombre');
    let distinctOrder = distinct.sort(function (a, b) {
        return a.nombre.localeCompare(b.nombre);
    });
    return distinctOrder
}